import styles from './EligibilityBlock.module.scss';
import { BaseText, EBaseTextSize } from '@spinwise/react-component-library/BaseText';
import { EBrandTextColor } from 'Libraries/typography.library';

const EligibilityBlock = ({ title, disclaimer, item, sportsbook_calculations }) => (
  <>
    <div className={styles.eligibility_container}>
      <div className={styles.eligibility_block}>
        <div className={`${styles.eligibility_block__header}`}>{title}</div>
        <ul>
          {item.map(el => {
            return (
              <li key={el?.id} className={`${styles.eligibility_block__item} d-fl ai-c`}>
                <div className={'d-fl'}>
                  <img src={'/images/icons/check-mark-cashback.svg'} alt="" width={20} height={20} />
                </div>
                <div>
                  <p className={styles.eligibility_block__item_title}>{el?.title}</p>
                </div>
              </li>
            );
          })}
        </ul>
        <div className={`${styles.eligibility_block__item_disclaimer} d-fl`}>
          <span>*</span>
          <p>{disclaimer}</p>
        </div>
        {sportsbook_calculations && (
          <div className={`${styles.eligibility_block__item__sportsbook_calculations} d-fl`}>
            <BaseText
              value={sportsbook_calculations}
              color={EBrandTextColor.White}
              size={EBaseTextSize.Small}
            ></BaseText>
          </div>
        )}
      </div>
    </div>
  </>
);

export default EligibilityBlock;
